import { graphql } from 'codegen/src/help'

export const GET_FRENQUENTLY_ASKED_QUESTIONS = graphql(`
	query GetFrequentlyAskedQuestions(
		$locale: String!
		$isOutlet: Boolean! = false
	) {
		allFaq: all_faq(locale: $locale, limit: 1) {
			items {
				content {
					...FaqContent
				}
				outletContent: outlet_content @include(if: $isOutlet) {
					...FaqOutletContent
				}
			}
		}
	}
`).toString()

export const GET_QUESTIONS_BY_CATEGORY_KEY = graphql(`
	query GetQuestionsByCategoryKey(
		$locale: String!
		$categoryKey: String
		$isOutlet: Boolean! = false
	) {
		allCategory: all_category(
			locale: $locale
			limit: 1
			where: { title: $categoryKey }
		) {
			items {
				categoryKey: title
				content {
					...CategoryContent
				}
				outletContent: outlet_content @include(if: $isOutlet) {
					contentOverwriteSelector: content_overwrite_selector
					...CategoryOutletContent
				}
			}
			total
		}
	}
`).toString()

export const GET_QUESTION_BY_ID = graphql(`
	query GetQuestionById(
		$locale: String!
		$questionKey: String!
		$isOutlet: Boolean! = false
	) {
		allQuestion: all_question(
			locale: $locale
			limit: 1
			where: { title: $questionKey }
		) {
			items {
				questionKey: title
				content {
					...QuestionContent
				}
				outletContent: outlet_content @include(if: $isOutlet) {
					contentOverwriteSelector: content_overwrite_selector
					...QuestionOutletContent
				}
			}
			total
		}
	}
`).toString()
